// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PJYF","questions":"styles_questions__3iOr8","footer":"styles_footer__1qRyX"};